import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import './TimeRangeSelector.css';

const TimeRangeSelector = ({ value, onChange }) => {
    const [customRange, setCustomRange] = useState({
        start: new Date(),
        end: new Date()
    });

    const handleCustomRangeChange = (dates) => {
        const [start, end] = dates;
        setCustomRange({ start, end });
        onChange({ type: 'custom', start, end });
    };

    return (
        <div className="time-range-selector">
            <h2 style={{ paddingBottom: '12px' }}>Oklahoma HB 3214</h2>
            {/* <div className="time-range-options">
            <button 
                    className={`range-btn ${value === 'yesterday' ? 'active' : ''}`}
                    onClick={() => onChange('yesterday')}
                >
                    Yesterday
                </button>
                <button 
                    className={`range-btn ${value === 'today' ? 'active' : ''}`}
                    onClick={() => onChange('today')}
                >
                    Today
                </button>
                
                <button 
                    className={`range-btn ${value === 'last_7_days' ? 'active' : ''}`}
                    onClick={() => onChange('last_7_days')}
                >
                    Last 7 Days
                </button>
                <button 
                    className={`range-btn ${value === 'last30days' ? 'active' : ''}`}
                    onClick={() => onChange('last30days')}
                >
                    Last 30 Days
                </button>
                <DatePicker
                    selectsRange={true}
                    startDate={customRange.start}
                    endDate={customRange.end}
                    onChange={handleCustomRangeChange}
                    className="custom-date-picker"
                    placeholderText="Custom Range"
                />
            </div> */}
        </div>
    );
};

export default TimeRangeSelector;